module.exports = __webpack_public_path__ + "5779b64ff2ef5d993cfe7b55bd1c87bd.png";